import { A, reactive, Span, Div, not } from 'alkali'
import * as helpIcon from 'icons/question-circle.svg'
import { track } from 'components/tracking/track'
import Icon from 'components/Icon'
import app from 'app/app'
import Dropdown from '../generic/Dropdown'
import * as reportIcon from 'icons/alert-message-laptop.svg'
import * as manualIcon from 'icons/programming-book.svg'
import * as tourIcon from 'icons/question-circle.svg'
import * as emailIcon from 'icons/email-action-unread.svg'
import { usersnapOpen } from 'integrations/usersnap'
import { Chat } from 'integrations/intercom'
import { ChatOption } from './ChatOption'
import { startExplanations, showingExplanation } from 'components/entry/Explanation'
import { faqOrReadOnly, showLiveAnalysis } from 'model/SearchQuery'
import { ready } from 'jquery'
import { 
	tourRunner, 
	tourSection, 
	removeContents, 
	textReset, 
	welcomePageMap as welcomePage, 
	quickAnalysisMap as quickAnalysis } from 'components/entry/Tour'
import { completeWorkflowMap as completeWorkflow } from 'components/entry/WorkflowTour'

export const HelpIcon = Div('#nav-help.nav-tab', {
	title: 'Need Help?',
	onclick(event) {
		if (!this.dropdown) {
			this.dropdown = new Dropdown('.view-drop-down', {
				alignRight: true,
				items:
					faqOrReadOnly.valueOf() ? [ //ChatOption,
						{
							content: A('.help-link', {
								href: 'mailto:support@drevidence.com',
							}, [Icon({ icon: emailIcon }), Span('.email-link', ['Email Support'])])
						},
						{
							content: [Icon({ icon: reportIcon }), Span('Report Error')],
							onclick: () => usersnapOpen()
						}] :
						[ // ChatOption,
							{
								content: A('.help-link', {
									content: [Icon({ icon: manualIcon }), Span('FAQs + Tips')],
									target: '_blank',
									onclick() {
										track({ event: 'help-manual' })
									},
									href: faqOrReadOnly.valueOf() ?
										'https://confluence.doctorevidence.com/display/shareit/76120078/PAH81063843a6624f2582d3b213a1efba07POG' :
										'https://confluence.doctorevidence.com/display/shareit/67502210/YZT9f6505f2c655461ebe29b0baae7b7e22FCB'
								})
							},
							{
								content: A('.help-link', {
									href: 'mailto:support@drevidence.com',
								}, [Icon({ icon: emailIcon }), Span('.email-link', ['Email Support'])])
							},
							{
								content: A('.help-link', {
									content: [Icon({ icon: manualIcon }), Span('Download Quick Guide')],
									target: '_blank',
									onclick() {
										track({ event: 'help-quick-guide' })
									},
									href: 'images/DocAnalytics-Quick-Guide.pdf'
								})
							},
							{
								content: [Icon({ icon: reportIcon }), Span('Report Error')],
								onclick: () => usersnapOpen()
							},							
							{
								content: [Icon({ icon: tourIcon }), Span('Tour')],
								onclick: () => {
									removeContents()
									textReset()
									document.querySelector('.search-results') 
										? tourRunner(quickAnalysis, 0) 
										: tourRunner(welcomePage, 0)
									this.dropdown.classList.remove('nested-dropdown')
								},
								onmouseover: () => !document.querySelector('.search-results') ? null : this.dropdown.classList.add('nested-dropdown'),
							},
							{
								classes: {
									'tour-help': true
								},
								content: [Span('.quick-analysis-tour', 'Quick Analysis')],
								onclick: () => {
									tourSection.put('QuickAnalysis')
									removeContents()
									textReset()
									tourRunner(quickAnalysis, 1)
									showLiveAnalysis.put(false)
									this.dropdown.classList.remove('nested-dropdown')
								},
							},
							{
								classes: {
									'tour-help': true,
								},
								content: [Span('.complete-workflow-tour', 'Complete Workflow')],
								onclick: () => {
									tourSection.put('CompleteWorkflow')
									removeContents()
									textReset()
									tourRunner(completeWorkflow, 0)
									this.dropdown.classList.remove('nested-dropdown')
								},
							},
						]
					})
				}

		if (Chat.dialog?.visible.valueOf()) {
			Chat.dialog.toggle(false)
		} else {
			this.dropdown.show(event)
			this.dropdown.classList.remove('nested-dropdown')
		}
	},
	ready() {
		this.append([
			Span(['Need Help']),
			Icon({ icon: helpIcon }),
		])
	}
})
